import React, { forwardRef, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import track from "src/utils/analytics";
import useSideNav from "src/hooks/useSideNav";

const Page = forwardRef(({ children, title = "", style, ...rest }, ref) => {
    const location = useLocation();
    const { fullscreenMode } = useSideNav();

    const sendPageViewEvent = useCallback(() => {
        track.pageview({
            page_path: location.pathname,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        sendPageViewEvent();
    }, [sendPageViewEvent]);

    return (
        <div
            ref={ref}
            {...rest}
            style={{
                ...style,
                ...(fullscreenMode ? { paddingLeft: 0, paddingRight: 0 } : {}),
            }}
        >
            <Helmet>
                <title>{title}</title>
            </Helmet>
            {children}
        </div>
    );
});

Page.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
};

export default Page;
